// https://icones.js.org/

export enum FileIds {
    // apps
    THEME_LIGHT = 'THEME_LIGHT',
    THEME_DARK = 'THEME_DARK',
}
